import {ReactComponent as CopyIcon} from './copy.svg'

function Copy() {
  return <CopyIcon />
}

export default Copy
